import { Component, OnInit, Inject } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { AlertService, CanonicalService, MenuService, TokenStorage } from '@foo/foo-web-framework';
import { get } from 'lodash';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})

export class AppComponent implements OnInit {

  staticAlertClosed = false;
  subscribeAlert: any;
  subscribegEvent: any;
  alertMessage: string;
  alertType: string;
  showAlert = false;
  showBackground = true;
  _isrtl = false;

  get isrtl(): boolean {
    return this._isrtl;
  }

  set isrtl(value: boolean) {
    this.dom.querySelector('body').dir = value ? 'rtl' : 'ltr';
    this.dom.querySelector('body').className = value ? ' page-body direction-rtl' : 'page-body direction-ltr';
    if (window['moduleName']) {
      this.dom.querySelector('body').className += ` ${window['moduleName']}`;
    } else {
      this.dom.querySelector('body').className += ' app';
    }
    this._isrtl = value;
  }

  constructor(@Inject(DOCUMENT) private dom,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private canonicalService: CanonicalService,
    private titleService: Title,
    private translate: TranslateService,
    private tokenStorage: TokenStorage,
    private alert: AlertService ) {

  }



  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  ngOnInit() {
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    });


    const hostName = this.dom.location.origin;
    // handler for alert boxes
    this.subscribeAlert = this.alert.getAlert()
      .subscribe(item => {
        this.alertMessage = item?.text;
        this.alertType = item?.type;
        this.showAlert = true;
        setTimeout(() => {
          this.showAlert = false;
        }, 3000);
      });

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    )
      .subscribe((event) => {
        if (event.title) this.setTitle(`AEC Wallet - ${this.translate.instant(event.title)}`);
        // Set Canonical URL
        if (event.canonical) {
          this.canonicalService.updateCanonicalUrl(hostName + event.canonical);
        } else {
          this.canonicalService.updateCanonicalUrl(hostName + this.router.url);
        }
        this.showBackground = event.skylineBackground;

        if (sessionStorage.getItem('userId') !== null) {
          let usrId = sessionStorage.getItem('userId');
          if (localStorage.getItem('device_uid_cookie')) {
            usrId += localStorage.getItem('device_uid_cookie');
          }
          this.tokenStorage.setRtoken(usrId);
        } else if (!sessionStorage.getItem('userId') && !this.tokenStorage.getRtoken()) {
          this.tokenStorage.setRtoken(this.randomString(32, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'));
        }

      });


    // Code commented temporarily

    // setting the lang RTL
    if (!window['moduleName']) {
      // @ts-ignore
      if (localStorage.getItem('curLang')) {
        if (localStorage.getItem('curLang') == 'ar') {
          this.isrtl = true;
        }
      } else {
        localStorage.setItem('curLang', 'en');
        this.isrtl = false;
      }
    } else {
      let lang = this.tokenStorage.getCurrentLanguage() || get(window, 'lang');
      if (lang === 'ar') {
        this.isrtl = true;
        this.translate.use('ar');
      } else {
        this.isrtl = false;
        this.translate.use('en');
      }
    }
    this.translate.onLangChange.subscribe(({ lang }) => {
      if (!window['moduleName']) {
        localStorage.setItem('curLang', lang);
      }
      if (lang === 'ar') {
        this.isrtl = true;
      } else {
        this.isrtl = false;
      }
    });
  }

  randomString(length, chars) {
    let result = '';
    for (let i = length; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
  }

}
